"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradingEntityMode = exports.TaxRatesBootstrap = exports.TaxRateActivateRequest = exports.TaxRateCategoriesResponse = exports.TaxCategoryView = exports.TaxRateActive = exports.TaxCategoryDef = exports.TaxCatalogue = void 0;
exports.effectiveTaxRatePercent = effectiveTaxRatePercent;
const zod_1 = require("zod");
const country_pack_js_1 = require("./country-pack.js");
Object.defineProperty(exports, "TaxCatalogue", { enumerable: true, get: function () { return country_pack_js_1.TaxCatalogue; } });
Object.defineProperty(exports, "TaxCategoryDef", { enumerable: true, get: function () { return country_pack_js_1.TaxCategoryDef; } });
/**
 * One row in the BOS-side `tax_rates` table, projected as wire JSON.
 * Effective-dated per TRS §30.16: `activeUntil = null` is the current
 * row for a `(countryPackId, taxCategory)` pair.
 */
exports.TaxRateActive = zod_1.z.object({
    id: zod_1.z.string(),
    countryPackId: zod_1.z.string(),
    taxCategory: zod_1.z.string(),
    ratePercent: zod_1.z.number().min(0).max(100),
    activeFrom: zod_1.z.string().datetime(),
    activeUntil: zod_1.z.string().datetime().nullable(),
});
/**
 * Joined view: every category from the pack catalogue paired with
 * its current active rate (or null). Returned by
 * `GET /tax-rates/categories?countryPackId=…` for the admin UI.
 */
exports.TaxCategoryView = zod_1.z.object({
    id: zod_1.z.string(),
    displayName: zod_1.z.string(),
    allowedRates: zod_1.z.array(zod_1.z.number().min(0).max(100)).min(1),
    defaultRate: zod_1.z.number().min(0).max(100).nullable(),
    currentRate: zod_1.z.number().min(0).max(100).nullable(),
    currentRateActiveSince: zod_1.z.string().datetime().nullable(),
});
exports.TaxRateCategoriesResponse = zod_1.z.object({
    countryPackId: zod_1.z.string(),
    categories: zod_1.z.array(exports.TaxCategoryView),
});
exports.TaxRateActivateRequest = zod_1.z
    .object({
    ratePercent: zod_1.z.number().min(0).max(100),
})
    .strict(); // H-73: reject unknown request-body keys
/**
 * `taxRates` field added to `/sync/catalog/bootstrap` in Sprint 3.
 * Map of `taxCategory` → current `ratePercent`. Categories with no
 * active rate are OMITTED from this map so the terminal hard-fails
 * on sale of items in those categories rather than silently
 * zero-rating.
 */
exports.TaxRatesBootstrap = zod_1.z.record(zod_1.z.string(), zod_1.z.number().min(0).max(100));
/**
 * Which legal entity the till is trading as (YUKI-35).
 *
 * Ukrainian retailers commonly begin as an individual entrepreneur and
 * incorporate later. The two are not a branding difference: they change the
 * VAT charged on every line, and therefore the fiscal document.
 *
 * - `individual_entrepreneur` — every line sells at 0 % regardless of its tax
 *   category. The category is still carried and still reported; it simply does
 *   not produce a rate in this mode.
 * - `llc` — tax categories resolve to their real rates.
 *
 * Deliberately explicit rather than inferred from "are all the rates zero".
 * An estate midway through incorporating will have both kinds of terminal
 * running against one catalogue, and a till must know which it is rather than
 * deduce it from data that is briefly ambiguous.
 */
exports.TradingEntityMode = zod_1.z.enum(['individual_entrepreneur', 'llc']);
/**
 * Resolves the rate actually charged for a tax category under a trading mode.
 *
 * The single place this decision is made, so the receipt renderer, the fiscal
 * payload and any report cannot disagree about what a line was taxed at.
 *
 * `ratePercent` is the category's configured rate as a decimal string; the
 * return keeps that form because these values reach a fiscal document and must
 * not pass through a float.
 */
function effectiveTaxRatePercent(mode, ratePercent) {
    return mode === 'individual_entrepreneur' ? '0' : ratePercent;
}
//# sourceMappingURL=tax-rates.js.map